import Home from "../pages/Home";

import PublicLayout from "../components/layouts/PublicLayout";
import Tracking from "../pages/Tracking";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import RequestPassword from "../pages/requestPassword";
import ResetPassword from "../pages/resetPassword";
import VerifyEmail from "../pages/verifyEmail";
import Feedback from "../pages/Feedback";

import OptInPage from "../pages/OptInPage";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";

export const publicRoutes = [
  {
    path: "/",
    element: (
      <PublicLayout>
        <Home />
      </PublicLayout>
    ),
  },
  {
    path: "/tracking",
    element: (
      <PublicLayout>
        <Tracking />
      </PublicLayout>
    ),
  },
  {
    path: "/optin",
    element: (
      <PublicLayout>
        <OptInPage />
      </PublicLayout>
    ),
  },
  {
    path: "/track/:trackingId",
    element: (
      <PublicLayout>
        <Tracking />
      </PublicLayout>
    ),
  },
  {
    path: "/track/:trackingId/feedback",
    element: (
      <PublicLayout>
        <Feedback />
      </PublicLayout>
    ),
  },
  {
    path: "auth/login",
    element: (
      <PublicLayout>
        <Login />
      </PublicLayout>
    ),
  },
  {
    path: "auth/signup",
    element: (
      <PublicLayout>
        <SignUp />
      </PublicLayout>
    ),
  },
  {
    path: "auth/request-password",
    element: (
      <PublicLayout>
        <RequestPassword />
      </PublicLayout>
    ),
  },
  {
    path: "auth/verify-email",
    element: (
      <PublicLayout>
        <VerifyEmail />
      </PublicLayout>
    ),
  },
  {
    path: "auth/reset-password",
    element: (
      <PublicLayout>
        <ResetPassword />
      </PublicLayout>
    ),
  },
  {
    path: "/terms",
    element: (
      <PublicLayout>
        <TermsAndConditions />
      </PublicLayout>
    ),
  },
  {
    path: "/privacy",
    element: (
      <PublicLayout>
        <PrivacyPolicy />
      </PublicLayout>
    ),
  },
];
